import { TScalarImmutable } from './immutable';

type TByte = number;
type TBytes = TScalarImmutable<TByte[]>;

function isBuffer(value: unknown): value is Buffer {
  return Buffer.isBuffer(value);
}

export { TByte, TBytes, isBuffer };
